import Cookies from 'js-cookie';

const authInitialState = {
    loggedIn: Cookies.get('accessToken') ? true : false,
    user: Cookies.get('authUser') ? JSON.parse(Cookies.get('authUser')) : '',
    // defaultImg: '/images/male-teacher.png',
    role: '',
    subDomain: '',
};

export default authInitialState;